"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Badge = function Badge(_ref) {
  var children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "size", "disabled", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledBadge, _extends({
    size: size,
    disabled: disabled,
    className: className
  }, otherProps), children);
};

var StyledBadge = _styledComponents.default.div.withConfig({
  displayName: "StyledBadge"
})(["width:", ";height:", ";background-color:", ";border-radius:999px;display:flex;justify-content:center;align-items:center;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:white;"], function (_ref2) {
  var size = _ref2.size;
  return size === 'normal' ? '3.2rem' : size === 'small' ? '1.6rem' : '3.2rem';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'normal' ? '3.2rem' : size === 'small' ? '1.6rem' : '3.2rem';
}, function (_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;
  return disabled ? '#D4D4D4' : theme.brand.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'normal' ? '500' : '400';
}, function (_ref7) {
  var size = _ref7.size;
  return size === 'normal' ? '1.6rem' : '1rem';
}, function (_ref8) {
  var size = _ref8.size;
  return size === 'normal' ? '1.6rem' : '1rem';
});

Badge.defaultProps = {
  size: 'normal'
};
Badge.propTypes = {
  /** Content to be displayed inside of the badge. */
  children: _propTypes.node.isRequired,

  /** Size of the badge ("normal" / "small"). */
  size: _propTypes.string,

  /** If set to true, will be more greyed out. */
  disabled: _propTypes.bool,

  /** Extra classname to pass to the element. */
  className: _propTypes.string,

  /** Extra props to pass to the element. */
  otherProps: _propTypes.object
};
var _default = Badge;
exports.default = _default;